var map = {
	"./kabutocho-dark.svg": 1157,
	"./kabutocho-light.svg": 1158,
	"./long-dark-colored.svg": 1688,
	"./long-dark-monochrome-outline.svg": 1689,
	"./long-dark-monochrome-transparent.svg": 1690,
	"./long-dark-monochrome.svg": 1691,
	"./long-light-colored-transparent.svg": 1692,
	"./long-light-colored.svg": 1693,
	"./long-light-monchrome.svg": 1694,
	"./long-light-monochrome-outline.svg": 1695,
	"./long-light-monochrome-transparent.svg": 1696,
	"./short-dark-logo.svg": 862,
	"./short-light-logo.svg": 863,
	"./square-dark-colored.svg": 1697,
	"./square-dark-monochrome-outline.svg": 1698,
	"./square-dark-monochrome-transparent.svg": 1699,
	"./square-dark-monochrome.svg": 1700,
	"./square-light-colored-transparent.svg": 1701,
	"./square-light-colored.svg": 861,
	"./square-light-monochrome-outline.svg": 1702,
	"./square-light-monochrome-transparent.svg": 1703,
	"./square-light-monochrome.svg": 1704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1687;